"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIE = void 0;
function isIE() {
    return Boolean(document.documentMode);
}
exports.isIE = isIE;
//# sourceMappingURL=browserDetection.js.map